// Externe Bibliotheken
import React, { useState, useEffect, useCallback } from 'react';

// Interne Module
import * as storage from '@/_helper/storage';
import _ from 'lodash';

// Styles
import './multipleTabs.scss';

export function DetectMultipleTabs({ travelType = null }) {
    const [block, setBlock] = useState(false);

    const Detect = useCallback(() => {
        if (storage.get('access_token') === null) {
            return false;
        }

        let tabID = null,
            tabStorage;

        // check storage : change
        window.addEventListener('storage', (event) => {
            if (localStorage?.tabs) {
                tabStorage = JSON.parse(localStorage.tabs);
                logic();
            }

            // reload other tabs
            if (localStorage?.tabRefresh) {
                window.location.reload();
                localStorage.removeItem('tabRefresh');
            }
        });

        // check hashchange : change
        window.addEventListener(
            'hashchange',
            () => {
                if (localStorage?.tabs) {
                    let list = ['#/', '#/zusatzleistung'];
                    if (list.includes(window.location.hash)) {
                        if (tabStorage.hasOwnProperty(sessionStorage.tabID)) {
                            let storageHelper = JSON.parse(localStorage.tabs);
                            delete storageHelper[sessionStorage.tabID];
                            delete storageHelper['booking'];
                            localStorage.tabs = JSON.stringify(storageHelper);
                        }
                    }
                }

                if (localStorage?.tabs) {
                    let storageHelper = JSON.parse(localStorage.tabs);
                    if (tabStorage.hasOwnProperty(sessionStorage.tabID)) {
                        delete storageHelper[sessionStorage.tabID];
                    }
                    if (window.location.hash.includes('buchung')) {
                        let bookingState = storageHelper.booking !== undefined ? storageHelper.booking : [];
                        if (!bookingState.includes(travelType)) {
                            bookingState.push(travelType);
                        }
                        storageHelper.booking = bookingState;
                    } else {
                        delete storageHelper['booking'];
                    }
                    localStorage.tabs = JSON.stringify(storageHelper);
                }
            },
            false
        );

        const removeOpenTabFromSession = () => {
            sessionStorage.removeItem('__lock');

            if (localStorage?.tabs) {
                if (!window.location.hash.includes('buchung')) {
                    let storageHelper = JSON.parse(localStorage.tabs);
                    delete storageHelper[sessionStorage.tabID];
                    delete storageHelper['booking'];
                    localStorage.tabs = JSON.stringify(storageHelper);
                }
            }
        };

        window.addEventListener('unload', removeOpenTabFromSession);
        window.addEventListener('beforeunload', removeOpenTabFromSession);

        if (sessionStorage.getItem('__lock')) {
            sessionStorage.removeItem('tabID');
        }
        sessionStorage.setItem('__lock', '1');

        // set storage
        tabStorage = localStorage.tabs ? JSON.parse(localStorage.tabs) : {};

        // set tabID
        tabID = sessionStorage.tabID
            ? sessionStorage.tabID
            : (sessionStorage.tabID = Object.keys(tabStorage).length + 1 + '-' + Math.floor(Math.random() * 1000));

        // set timestamp -> current tabID
        if (!tabStorage.hasOwnProperty(tabID)) {
            tabStorage[tabID] = tabStorage[tabID]?.[travelType] !== undefined ? tabStorage[tabID][travelType] : {};
            tabStorage[tabID][travelType] = Date.now();
        }

        // set tabs storage
        localStorage.tabs = JSON.stringify(tabStorage);

        // init block layer
        function logic() {
            let storageHelperCurrentTravelType = [];

            // get elements by travelType
            Object.keys(tabStorage).forEach(function (o) {
                if (Object.keys(tabStorage[o]).includes(travelType)) {
                    storageHelperCurrentTravelType.push(o);
                }
            });

            // no way
            if (storageHelperCurrentTravelType.length === 0) {
                return false;
            }

            // sort by timestamp
            storageHelperCurrentTravelType.sort(function (a, b) {
                if (tabStorage.booking !== undefined && tabStorage.booking.includes(travelType)) {
                    return tabStorage[b][travelType] - tabStorage[a][travelType];
                } else {
                    return tabStorage[a][travelType] - tabStorage[b][travelType];
                }
            });

            if (tabID === storageHelperCurrentTravelType[0] && storageHelperCurrentTravelType.length > 0) {
                setBlock(false);
            } else {
                setBlock(true);
            }

            // block on booking state
            _.delay(function () {
                if (
                    JSON.parse(localStorage.tabs) !== undefined &&
                    JSON.parse(localStorage.tabs).booking !== undefined &&
                    JSON.parse(localStorage.tabs).booking.includes(travelType)
                ) {
                    setBlock(true);
                }
            }, 0);
        }

        logic();
    }, [travelType]);

    function initBlock() {
        if (!block) {
            return false;
        }

        return (
            <section className="multi-tabs-info">
                <div className="icon"></div>
                <div>
                    <p>Es sind mehre Tabs geöffnet.</p>
                </div>
                <div>
                    <p>Schließen Sie diesen Tab.</p>
                </div>
            </section>
        );
    }

    useEffect(() => {
        Detect();
    }, [Detect]);

    return <>{initBlock()}</>;
}

export default DetectMultipleTabs;
